// src/pages/instruccion/Camaras.jsx

const oficiales = [
  { cargo: "V.·.M.·.I.·.", nombre: "Fernando Britto Obregón", logia: "3" },
  { cargo: "Past V.·.M.·.I.·. Inmediato", nombre: "Armando Pareja Chinen", logia: "142" },
  { cargo: "V.·.M.·. 1er. Vig.·.", nombre: "Santiago Rodriguez Campos", logia: "142" },
  { cargo: "V.·.M.·. 2do. Vig.·.", nombre: "Carlos Oviedo Hansssen", logia: "134" },
  { cargo: "V.·.M.·. Capellán", nombre: "Luis Chapilliquen Rivasplata", logia: "" },
  { cargo: "V.·.M.·. Sec.·.", nombre: "Alfredo Ponce Diaz", logia: "" },
  { cargo: "V.·.M.·. Tes.·.", nombre: "Julio Sandoval Lizama", logia: "" },
  { cargo: "V.·.M.·. D.·. de C.·.", nombre: "Samuel Anchaya Campanella", logia: "" },
  { cargo: "V.·.M.·. 1er. Diác.·.", nombre: "Atilio Leveratto Escala", logia: "" },
  { cargo: "V.·.M.·. 2do. Diác.·.", nombre: "Segundo Soller Rodriguez", logia: "" },
  { cargo: "V.·.M.·. G.·.T.·.I.·.", nombre: "Eduardo Flores Mendieta", logia: "" },
  { cargo: "V.·.M.·. G.·.T.·.E.·.", nombre: "Raúl Pizarro Huillca", logia: "" }
];

const Camaras = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white selection:bg-[#C5A059] selection:text-[#050505] font-sans pt-24 flex flex-col">
      
      {/* Hero Section */}
      <section className="relative w-full pt-32 pb-16 md:pt-40 md:pb-24 flex flex-col items-center justify-center overflow-hidden border-b border-white/5">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
          style={{ backgroundImage: "url('https://images.unsplash.com/photo-1507676184212-d0350eb05dda?q=80&w=2000&auto=format&fit=crop')" }} 
        ></div>
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/90 via-[#050505]/60 to-[#050505]"></div>

        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <p className="text-[#C5A059] tracking-[0.4em] uppercase text-xs md:text-sm font-light mb-4 animate-fade-in">
            Instrucción Masónica
          </p>
          <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl font-normal text-white tracking-tight animate-fade-in [animation-delay:0.3s] drop-shadow-lg mb-4">
            Cámara de VV.·.MM.·.II.·.
          </h1>
          <h2 className="font-serif text-2xl md:text-3xl italic font-light text-gray-300 animate-fade-in [animation-delay:0.5s] mb-8">
            "Antonio Arenas Merino"
          </h2>
        </div>
      </section>

      {/* Sección 1: Cuadro de Dignidades y Oficiales */}
      <section className="relative z-20 max-w-[90rem] mx-auto px-6 lg:px-12 py-16 md:py-24">
        
        <div className="mb-12 border-b border-white/10 pb-6 flex flex-col md:flex-row justify-between md:items-end gap-4">
          <div>
            <span className="text-[#C5A059] text-[10px] tracking-[0.3em] uppercase mb-2 block">Directorio</span>
            <h3 className="font-serif text-3xl md:text-4xl text-white font-normal">Cuadro de DD.·. y OO.·.</h3>
          </div>
          <div className="text-left md:text-right">
            <p className="text-gray-400 text-xs tracking-widest uppercase">Periodo 2025 - 2026 E.·.V.·.</p>
            <p className="text-[#C5A059] text-[10px] tracking-widest uppercase border border-[#C5A059]/30 px-2 py-1 mt-2 inline-block">Decreto 143-371 GLP</p>
            <p className="text-gray-500 text-[10px] uppercase tracking-widest mt-2">07 de Mayo 2025</p>
          </div>
        </div>

        {/* Grilla de Oficiales */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6">
          
          {/* Primeros dos cargos destacados (V.M.I y Past V.M.I) */}
          {oficiales.slice(0, 2).map((oficial, idx) => (
            <div key={idx} className={`p-6 md:p-8 ${idx === 0 ? 'bg-gradient-to-br from-[#0a0a0a] to-[#111111] border-t-2 border-[#C5A059] shadow-xl md:col-span-2 lg:col-span-1' : 'bg-[#0a0a0a] border border-white/5 hover:border-[#C5A059]/30'}`}>
              <span className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-3 font-semibold">{oficial.cargo}</span>
              <p className="text-gray-500 text-[10px] tracking-widest uppercase mb-1">R.·. H.·.</p>
              <h4 className="font-serif text-2xl text-white mb-2">{oficial.nombre}</h4>
              {oficial.logia && (
                <p className="text-gray-400 text-xs font-light tracking-wide">Logia N° {oficial.logia}</p>
              )}
            </div>
          ))}

          {/* Resto de Oficiales */}
          {oficiales.slice(2).map((oficial, idx) => (
            <div key={idx + 2} className="bg-[#050505] border border-white/5 p-6 hover:bg-white/[0.02] transition-colors">
              <span className="text-gray-400 text-[10px] tracking-[0.2em] uppercase block mb-3 font-semibold border-b border-white/5 pb-2 inline-block">{oficial.cargo}</span>
              <p className="text-gray-600 text-[10px] tracking-widest uppercase mb-1">R.·. H.·.</p>
              <h4 className="font-serif text-lg text-gray-300 mb-2">{oficial.nombre}</h4>
              {oficial.logia && (
                <p className="text-gray-500 text-xs font-light tracking-wide">Logia N° {oficial.logia}</p>
              )}
            </div>
          ))}
        </div>

      </section>

      {/* Sección 2: Reseña Histórica (Lectura Editorial) */}
      <section className="relative z-20 bg-[#0a0a0a] border-t border-white/5 py-16 md:py-24 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto">
          
          <div className="text-center mb-12">
            <span className="text-[#C5A059] text-[10px] tracking-[0.3em] uppercase mb-2 block">Legado</span>
            <h3 className="font-serif text-3xl md:text-4xl text-white font-normal">Reseña Histórica</h3>
            <div className="w-16 h-[1px] bg-[#C5A059] mx-auto mt-6"></div>
          </div>

          <div className="prose prose-invert prose-lg max-w-none text-gray-300 font-light leading-relaxed text-justify">
            <p className="mb-8">
              <span className="float-left text-7xl md:text-8xl text-[#C5A059] font-serif pr-4 leading-[0.8] mt-2 drop-shadow-md">
                L
              </span>
              a V.·. C.·. de VV.·.MM.·.II.·. “Antonio Arenas Merino” tiene una hermosa historia cuya creación oficial data del año 1925, pero ya desde el año 1887, ocho PP.·.VV.·.MM.·. de la R.·.L.·.S.·. “Orden y Libertad” N° 1, obligados a permanecer en Lima, mientras que la mayoría había acordado trasladarse para trabajar en el Vall.·. de Tacna, solicitaron Carta Constitutiva con el fin de establecer una Log.·. para el “Centro de Instrucción Masónica”. Esta Log.·. se instala el 7 de octubre de 1887 con el nombre de “Osiris” N° 1.
            </p>

            <p className="mb-8">
              La Log.·. “Osiris” N° 1 tuvo un desempeño, qué duda cabe, importante en nuestro país, pero, por razones que no se ha podido determinar, su labor fue intermitente hasta que en 1925, un insigne masón, como lo fue el M.·.R.·.H.·. Benjamín Pérez Treviño, extiende la Carta Constitutiva de la V.·. Log.·. de VV.·.MM.·.II.·. “Antonio Arenas Merino” de la cual fue su primer V.·.M.·. el R.·.H.·. Ángel Santos Parodi Vacaro (28) y posteriormente vinieron distinguidos representantes de nuestra Au.·. Ord.·. a reemplazarlo.
            </p>

            <div className="bg-[#050505] p-6 border-l-2 border-white/10 my-8">
              <p className="text-gray-400 text-sm md:text-base italic m-0">
                Entre ellos destacan los RR.·.HH.·. Max Arnillas Arana (3), Jorge A. Buttler M. (4), Ernesto Mispireta Dibarbouru (42), Luis Galliani Allende (62), José Zavala Pereyra (47), Miguel Monteverde Win (92), David Portillo Pomalaza (36), y sigue una larga lista.
              </p>
            </div>

            <p className="mb-8">
              Lo que fue la Log.·. de Perfección “Antonio Arenas Merino”, el año 1959, durante el gobierno del M.·.R.·.H.·. José Antonio Genit, y estando el R.·.H.·. Eduardo Mendoza Silva como V.·.M.·. de la ya mencionada Log.·. de Perfección, la Gran Asamblea de fecha 15 de mayo del citado año acordó llamarla <strong>V.·. C.·. de VV.·.MM.·.II.·. “Antonio Arenas Merino”</strong>, denominación que luce hasta nuestros días y ojalá por siempre.
            </p>

            <div className="text-center mt-12 pt-8 border-t border-white/5">
              <p className="text-[#C5A059] font-serif text-xl md:text-2xl">
                Actualmente, existen diez (10) V.·.C.·. de VV.·.MM.·.II.·. en las diferentes regiones que tiene la Gran Logia del Perú.
              </p>
              <p className="text-gray-600 text-[10px] tracking-widest uppercase mt-6">
                Actualizado el 12/04/2024
              </p>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
};

export default Camaras;